export const SECTIONS = {
  POLICY_INFORMATION: 1,
  APPLICANT_INFORMATION: 2,
  BROKER_INFORMATION: 3,
  POLICY_PERIOD: 4,
  APPLICANTS: 5,
  LOSS_HISTORY: 6,
  POLICY_HISTORY: 7,
  CROSS_REFERENCE_INFORMATION: 8,
  DWELLINGS: 9,
  PREMIUM_INFORMATION: 10,
  BROKER_QUESTIONNAIRE: 11,
  SUPPLEMENTS: 12,
  REMARKS: 13,
  DISCLOSURE_AND_ATTESTATION: 14,
};

export const SECTIONS_MENU = [
  {
    name: 'Policy Information',
    link: 'sectionPolicyInformation',
    section: SECTIONS.POLICY_INFORMATION,
  },
  {
    name: 'Applicant Information',
    link: 'sectionApplicantInformation',
    section: SECTIONS.APPLICANT_INFORMATION,
  },
  {
    name: 'Broker Information',
    link: 'sectionBrokerInformation',
    section: SECTIONS.BROKER_INFORMATION,
  },
  {
    name: 'Policy Period',
    link: 'sectionPolicyPeriod',
    section: SECTIONS.POLICY_PERIOD,
  },
  {
    name: 'Applicants',
    link: 'sectionApplicants',
    section: SECTIONS.APPLICANTS,
  },
  {
    name: 'Loss History',
    link: 'sectionLossHistory',
    section: SECTIONS.LOSS_HISTORY,
  },
  {
    name: 'Policy History',
    link: 'sectionPolicyHistory',
    section: SECTIONS.POLICY_HISTORY,
  },
  {
    name: 'Cross Reference Information',
    link: 'sectionCrossReferenceInformation',
    section: SECTIONS.CROSS_REFERENCE_INFORMATION,
  },
  {
    name: 'Dwellings',
    link: 'sectionDwellings',
    section: SECTIONS.DWELLINGS,
  },
  {
    name: 'Premium Information',
    link: 'sectionPremiumInformation',
    section: SECTIONS.PREMIUM_INFORMATION,
  },
  {
    name: 'Broker Questionnaire',
    link: 'sectionBrokerQuestionnaire',
    section: SECTIONS.BROKER_QUESTIONNAIRE,
  },
  {
    name: 'Supplements',
    link: 'sectionSupplements',
    section: SECTIONS.SUPPLEMENTS,
  },
  {
    name: 'Remarks',
    link: 'sectionRemarks',
    section: SECTIONS.REMARKS,
  },
  {
    name: 'Disclosure and Attestation',
    link: 'sectionDisclosureAndAttestation',
    section: SECTIONS.DISCLOSURE_AND_ATTESTATION,
  },
];

export const POLICY_HISTORY_REASONS_FOR_ENDING = [
  'Cancelled by Insurer',
  'Declined by Insurer',
  'Non-renewed by Insurer',
  'Insurer Restricted Coverage',
  'Cancelled by Insured',
  'Non-renewed by Insured',
];

export const POLICY_HISTORY_TERMINATED_BY_INSURER_REASONS = [
  'Insurance Fraud',
  'Loss History',
  'Material Misrepresentation',
  'No Prior Insurance',
  'Non-disclosure',
  'Non-payment',
];

export const RATING_PLANS = [
  'Basic',
  'Deluxe',
  'Preferred',
  'Superior',
  'Standard',
];
